// Generated from SVG to Code Figma Plugin

export const AudioPlayIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 48 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect height="24" width="48" fill="currentColor" fillOpacity="0.24" rx="12" />
    <path
      d="M20.8047 12V8.57143C20.8047 7.42857 22.0419 6.71429 23.0316 7.28571L26.0008 9L28.9701 10.7143C29.9598 11.2857 29.9598 12.7143 28.9701 13.2857L26.0008 15L23.0316 16.7143C22.0419 17.2857 20.8047 16.5714 20.8047 15.4286V12Z"
      fill="currentColor"
    />
  </svg>
);
